import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-support-chat-popup',
  templateUrl: './support-chat-popup.component.html',
  styleUrls: ['./support-chat-popup.component.scss'],
})
export class SupportChatPopupComponent implements OnChanges {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  hasBeenOpened = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && this.visible) {
      this.hasBeenOpened = true;
    }
  }

  onVisibleChange(next: boolean): void {
    this.visible = next;
    if (next) this.hasBeenOpened = true;
    this.visibleChange.emit(next);
  }
}
